var radiobox;

radiobox = function() {
  var $, modScope, module, moduleName;
  $ = require('jquery');
  moduleName = "radiobox";
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  modScope = module.parents('[data-checkscope]');
  return modScope.each(function() {
    var maxScopeTargets, status, thisCheckArrayElem, thisModName, thisModule, valueArray;
    thisCheckArrayElem = $(this).find('.checks-array');
    if (thisCheckArrayElem.length < 1) {
      $(this).prepend("<input type='hidden' class='checks-array jform__input' data-type='required'/>");
      thisCheckArrayElem = $(this).find('.checks-array');
    }
    maxScopeTargets = $(this).attr('data-max-targets');
    thisModule = $(this).find("." + moduleName);
    thisModName = $(this).attr('data-name');
    if (thisModName) {
      thisCheckArrayElem.attr('name', thisModName);
    }
    valueArray = [];
    status = thisModule.find("." + moduleName + "__status");
    status.change(function() {
      var siblings, that, thisStatus;
      that = $(this);
      thisStatus = that.val();
      siblings = that.parents('[data-checkscope]').find("." + moduleName + "__status").not(that);
      return valueArray = [];
    });
    return thisModule.click(function() {
      var _initThisLabel, checksInScope, clickedMod, i, labelIndex, thisLabel, thisStatus, thisStatusValue;
      clickedMod = $(this);
      thisStatus = clickedMod.find("." + moduleName + "__status");
      thisStatusValue = thisStatus.val();
      if (clickedMod.parents(".jform__field--error").length > 0) {
        clickedMod.parents(".jform__field--error").removeClass("jform__field--error");
      }
      thisLabel = void 0;
      _initThisLabel = function(thisObj) {
        return thisLabel = thisObj.parents('.b-form__check').find('.b-form__var').html();
      };
      if (maxScopeTargets) {
        i = 0;
        thisModule.each(function() {
          var self;
          self = $(this);
          if (self.hasClass(moduleName + "--enabled")) {
            return i++;
          }
        });
        if (i >= maxScopeTargets) {
          if (clickedMod.hasClass(moduleName + "--enabled")) {
            clickedMod.removeClass(moduleName + "--enabled");
            thisStatus.val('off');
            _initThisLabel(clickedMod);
            labelIndex = valueArray.indexOf(thisLabel);
            if (labelIndex >= 0) {
              valueArray.splice(labelIndex, 1);
            }
            thisCheckArrayElem.val(valueArray).change();
          }
          return false;
        }
      }
      clickedMod.toggleClass(moduleName + "--enabled");
      _initThisLabel(clickedMod);
      if (thisStatusValue === 'on') {
        thisStatus.val('off');
        labelIndex = valueArray.indexOf(thisLabel);
        if (labelIndex >= 0) {
          valueArray.splice(labelIndex, 1);
        }
        thisCheckArrayElem.val(valueArray).change();
      } else {
        thisStatus.val('on');
        valueArray.push(thisLabel);
        thisCheckArrayElem.val(valueArray).change();
      }
      checksInScope = modScope.find('.checkbox');
      if (checksInScope.length > 0) {
        checksInScope.removeClass('checkbox--enabled');
        return checksInScope.find('.checkbox__status').val('off').change();
      }
    });
  });
};

module.exports = radiobox;
